import IconButton from "./IconButton";

export { IconButton };

export default IconButton;
